import { formatBytes, formatUptime } from "./formatBytes";

export function aggregateDiskTotals(disks = []) {
	return disks.reduce(
		(acc, d) => ({
			size: acc.size + (d.size || 0),
			used: acc.used + (d.used || 0),
			available: acc.available + (d.available ?? 0),
		}),
		{ size: 0, used: 0, available: 0 }
	);
}

export function diskUsedPercent(totals) {
	if (!totals?.size) return 0;
	return Math.min(100, Math.max(0, (totals.used / totals.size) * 100));
}

export function buildSystemMetricSummary(data) {
	if (!data) return null;

	const cpu = Math.min(100, Math.max(0, Number(data.cpu?.currentLoad ?? 0)));
	const ram = Math.min(100, Math.max(0, Number(data.memory?.usedPercent ?? 0)));
	const diskTotals = aggregateDiskTotals(data.disks);
	const disk = diskUsedPercent(diskTotals);

	return {
		cpu,
		ram,
		disk,
		diskTotals,
		memory: data.memory,
		os: data.os,
		uptime: data.uptime,
	};
}

export function metricDetailLines(summary, i18n) {
	if (!summary) return {};
	const { memory, diskTotals, os, uptime } = summary;
	return {
		cpu: null,
		ram:
			memory != null
				? `${formatBytes(memory.used)} / ${formatBytes(memory.total)} · ${i18n.t("master.system.free")}: ${formatBytes(memory.free)}`
				: null,
		disk:
			diskTotals.size > 0
				? `${formatBytes(diskTotals.used)} / ${formatBytes(diskTotals.size)}`
				: null,
		uptime: uptime != null ? `${i18n.t("master.system.uptime")}: ${formatUptime(uptime)}` : null,
		host: os?.hostname ? `${os.hostname} · ${os.platform || ""} ${os.arch || ""}`.trim() : null,
	};
}
